/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ChartDatasetLineType {
    SOLID = 'SOLID',
    DASHED = 'DASHED',
    DOTTED = 'DOTTED'
}


export function ChartDatasetLineTypeFromJSON(json: any): ChartDatasetLineType {
    return ChartDatasetLineTypeFromJSONTyped(json, false);
}

export function ChartDatasetLineTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartDatasetLineType {
    return json as ChartDatasetLineType;
}

export function ChartDatasetLineTypeToJSON(value?: ChartDatasetLineType | null): any {
    return value as any;
}

